/**
 * useTaskCrud - Add, Delete, Duplicate task operations
 * 
 * Orchestrates CRUD operations from focused sub-modules.
 */
import {
  createAddTaskHandler,
  createConnectedTaskHandler,
  createInsertNodeOnEdgeHandler,
  createDeleteTaskHandler,
  createDeleteTasksHandler,
  createDuplicateTaskHandler,
} from './crud';

export const useTaskCrud = (localSprint, setLocalSprint, recordAction) => {
  return {
    handleAddTask: createAddTaskHandler(localSprint, setLocalSprint, recordAction),
    handleCreateConnectedTask: createConnectedTaskHandler(localSprint, setLocalSprint, recordAction),
    handleInsertNodeOnEdge: createInsertNodeOnEdgeHandler(localSprint, setLocalSprint, recordAction),
    handleDeleteTask: createDeleteTaskHandler(localSprint, setLocalSprint, recordAction),
    handleDeleteTasks: createDeleteTasksHandler(localSprint, setLocalSprint, recordAction),
    handleDuplicateTask: createDuplicateTaskHandler(setLocalSprint, recordAction),
  };
};

export default useTaskCrud;
